<template>
    <div class="DataTables NewLibraryFormULComponent ">

        <p><span v-if="isAll">
            <b-spinner small label="alert" type="grow" variant="danger"></b-spinner> {{ lang.infotext_3 }}
        </span></p>
        <span v-if="!isAll">
            
            <div role="group">
                <label for="input-name">Library name:</label>
                <b-form-input
                id="input-name"
                v-model="libraryName"
                :state="nameState"
                aria-describedby="input-name-help input-name-feedback"
                trim
                ></b-form-input>
            
                
                <b-form-invalid-feedback id="input-name-feedback">
                Enter another name of library. Such already exists.
                </b-form-invalid-feedback>
            
                
            </div>    
            <br>
            <!-- <p>
                <b-badge class="badge badge-blue">Request</b-badge> - {{ lang.infotext_2 }}
            </p> -->
            {{ lang.infotext_6 }}
            

            
        </span>
    </div>
</template>
<script>
import LoaderComponent from "@/components/shared/LoaderComponent"
import PartPropertiesType from '@/constants/PartPropertiesType'
import LibraryPropertiesType from '@/constants/LibraryPropertiesType'
import LibraryTypes from '@/constants/LibraryTypes'

export default {
    name: "NewLibraryFormULComponent",
    props: {
        lang: Object,
        source: String,
        libraryNumber: String
    },
    components: {

        LoaderComponent
    },
    data() {
        return {

            mainTable: "",
            id: "NewLibraryFormULComponent",
            properties: [],
            libraryTypes: [""],
            libraryFiles: null,
            existingLibraries: [],
            libraryName: ""
        }
    },
    computed: {
        nameState() {
            if (this.libraryName.length > 0) {
                if (this.existingLibraries.length > 0) {
                    for (let i = 0, lei = this.existingLibraries.length; i < lei; i++) {
                        if (this.existingLibraries[i].name.toLowerCase() == this.libraryName.toLowerCase()) {

                            return false;

                        }
                    }

                    return true;
                }
            } else {
                return false;
            }
            
            return true;
 
        },
        isAll() {
            
            if (this.libraryULObject.categoryId == 1) {
                
                return true; 

            }
            return false;
        },
        libraryULObject() {
            return this.$store.getters.libraryULObject;
        },
        categoryId() {
            return this.$store.getters.selectedTreeLibraryItemObject.categoryId;
        },
        categoryName() {
            return this.$store.getters.selectedTreeLibraryItemObject.category;
        },
        variant() {
            if (this.$store.getters.s_skinVariant == "dark") {
                return "light";
            } else {
                return "dark";
            }

        },
        libraryProperty() {

            const obj = {};
           
            for (let i = 0, lei = this.properties.length; i < lei; i++){

                if (this.properties[i].type === LibraryPropertiesType.LIBRARYNUMBER) {

                    obj.libraryNumberPropertyId = this.properties[i].propertyId
                    
                }
                if (this.properties[i].type === LibraryPropertiesType.LIBRARYTYPE) {

                    obj.typePropertyId = this.properties[i].propertyId

                }
            }

            return obj;
        }

    },
    created() {
        this.libraryName = this.libraryNumber;

        let type = this.source;
        if (this.source == PartPropertiesType.SYMBOL) {
            type = LibraryTypes.PART
        }
        

        const obj = {
            name: this.libraryName,
            type: type,
            
        }
        this.$store.commit("SETULLIBRARYNAME", obj);

        this.getproperties();

    },
    watch: {
        categoryId: function (newVal) {

            this.getproperties();
        },
        libraryName: function (newVal) {
            

            let type = this.source;
            if (this.source == PartPropertiesType.SYMBOL) {
                type = LibraryTypes.PART
            }

            const obj = {
                name: this.libraryName,
                type: type,

            }

            this.$store.commit("SETULLIBRARYNAME", obj);
        },
        nameState: function (newVal) {

            if (this.isAll == false && newVal == true) {
                this.$parent.setDisabledState(false);

                

            } else {
                this.$parent.setDisabledState(true);
            }
            
            
        },
        
        libraryULObject: {
            handler: function (newVal) {
                
                if (this.libraryULObject.categoryId === 1 && this.nameState == true) {
                    this.$parent.setDisabledState(true);


                } else {
                    
                    const objA = {
                        propertyId: this.libraryProperty.libraryNumberPropertyId,
                        value: this.libraryULObject.name,
                        
                    }
                    
                    this.$store.commit("ADDPROPERTYTOSAVINGUL", objA);
                    const objB = {
                        propertyId: this.libraryProperty.typePropertyId,
                        value: this.libraryULObject.type,
                        
                    }
                    
                    this.$store.commit("ADDPROPERTYTOSAVINGUL", objB);

                    

                    this.$parent.setDisabledState(false);
                }
              },
              deep: true
            
              
            },
    },
    updated() {

    },
    mounted: function () {

    },
    methods: {
        getproperties() {

            let vue = this;

            this.$store.dispatch(this.$store.getters.sectionPrefix + "_getULLibraryType")
                .then(function (result) {

                    console.log(result)

                    if (result.status == "OK") {

                        vue.libraryTypes = [""];
                        result.data.forEach(element => {
                            vue.libraryTypes.push(element.type);
                        });


                        let obj = {
                            categoryId: vue.categoryId

                        }

                        vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_getULProperties", obj)
                            .then(function (result) {

                                console.log(result)

                                if (result.status == "OK") {

                                    vue.properties = result.data;

                                    let action = "";
                                    if (vue.source == PartPropertiesType.SYMBOL) {
                                        action = "_getSymbols"
                                    }
                                    if (vue.source == PartPropertiesType.HDLSYMBOL) {
                                        action = "_getHDLSymbols"
                                    }
                                    if (vue.source == PartPropertiesType.FOOTPRINT) {
                                        action = "_getFootprints"
                                    }

                                    vue.$store.dispatch(vue.$store.getters.sectionPrefix + action, obj)
                                        .then(function (result) {

                                            console.log(result)

                                            if (result.status == "OK") {

                                                vue.existingLibraries = result.data;
                                                

                                                //vue.buildTable();
                                            }

                                        })

                                    
                                }

                            })
                        

                    }
                })



        },
        
        /*buildTable() {

            //this.$store.dispatch("resetPropertyToSaving");
            //this.$store.dispatch("resetLibraryFilesToSaving");

            for (let i = 0, lei = this.properties.length; i < lei; i++) {

                if (this.properties[i].isRequiredOnRequest == true) {
                    let obj = {
                        propertyId: this.properties[i].propertyId,
                        value: "",
                        type: this.properties[i].type,
                        isRequiredOnRequest: this.properties[i].isRequiredOnRequest
                    }
                    if (this.properties[i].type == "library number") {
                        obj.value = this.libraryNumber;
                    }
                    if (this.properties[i].type == "library type") {
                        obj.value = this.source;
                    }

                    //this.$store.dispatch("addPropertyToSavingUL", obj);
                    this.$store.commit("ADDPROPERTYTOSAVINGUL", obj);
                }


            }

            var tableplace = document.getElementById(this.id);
            if (tableplace == null) {
                return
            }
            while (tableplace.firstChild) {
                tableplace.removeChild(tableplace.firstChild);
            }

            var table = document.createElement("table");
            table.setAttribute("id", "t_" + this.id);
            table.setAttribute("class", "table table-striped table-bordered");
            table.setAttribute("style", "width:100%");
            tableplace.appendChild(table)

            var tr = document.createElement("tr");

            var thead = document.createElement("thead");
            thead.appendChild(tr);

            table.appendChild(thead);

            let vue = this;


            let cols = [
                { "data": "propertyId" },
                { "data": "priority" },
                { "data": "name" },

            ]

            let columns = [
                {
                    name: "Id",
                    alignInColumn: "left",

                },
                {
                    name: "Priority",
                    alignInColumn: "left",

                },
                {
                    name: this.lang.table_header_Name,
                    alignInColumn: "left",

                },
                {
                    name: this.lang.table_header_Value,
                    alignInColumn: "left",

                },



            ]




            var columnDefs = [];

            for (var i = 0, len = columns.length; i < len; i++) {

                let classname = '_dt-body-' + columns[i].alignInColumn;

                let el = {
                    targets: i,
                    className: classname,
                    render: function ( data, type, row, meta) {
                        if (data == null) {
                            data = "";
                        }

                        data = $.fn.dataTable.render.text().display(data);
                        if (data.display != undefined) {
                            data.display = $.fn.dataTable.render.text().display(data.display);
                        }
                        if (meta.col == 1) {


                            return data;
                        }
                        if (meta.col == 2) {
                            let required = "<span class=\"required\">";

                            if (row.isRequiredOnRequest == true) {
                                required += "<b-badge class=\"badge badge-blue\">Request</b-badge>";
                            }

                            required += "</span>"

                            return data + "   " + required;

                        }
                        if (meta.col == 3) {


                            if (row.type == "image") {

                                let img = "";


                                return img;
                            } else if (row.type == "text") {

                                let str = "";
                                str += "<div role=\"group\" class=\"input-group input-group-sm\">";
                                str += "<input data-type=\"" + row.type + "\" class=\"form-control new-part\" type=\"text\" id=\"value__" + row.propertyId + "__" + row.isRequiredOnRequest + "\" value=\"\">";
                                str += "</div>";
                                return str;
                            } else if (row.type == "library number") {
                                let str = "";
                                str += "<div role=\"group\" class=\"input-group input-group-sm\">";
                                str += "<input data-type=\"" + row.type + "\" class=\"form-control new-part\" type=\"text\" id=\"value__" + row.propertyId + "__" + row.isRequiredOnRequest + "\" value=\"" + vue.libraryNumber+"\">";
                                str += "</div>";
                                return str;
                                
                            } else if (row.type == "library type") {
                                // let str = "<select data-type=\"" + row.type + "\" class=\"form-control new-part type-select\" id=\"value__" + row.propertyId + "__" + row.isRequiredOnRequest + "\">";

                                // //const tab = ["", "Electric", "Mechanical", "Software"];
                                // for (let j = 0, lej = vue.libraryTypes.length; j < lej; j++) {

                                //     let selected = "";

                                //     str += "<option value=\"" + vue.libraryTypes[j] + "\" " + selected + ">" + vue.libraryTypes[j] + "</option>";
                                // }

                                // str += "</select>";
                                let str = "";
                                // str += "<div role=\"group\" class=\"input-group input-group-sm\">";
                                // str += "<input data-type=\"" + row.type + "\" class=\"form-control new-part\" type=\"text\" id=\"value__" + row.propertyId + "__" + row.isRequiredOnRequest + "\" value=\""+ vue.source+"\" disabled>";
                                // str += "</div>";
                                

                                return vue.source;

                            
                            } else if (row.type == LibraryTypes.PART || row.type == LibraryTypes.SYMBOL) {

                                let str = "a<div role=\"group\" class=\"input-group\">";
                                str += "<input data-type=\"" + row.type + "\" class=\"form-control form-control-sm new-part\"  type=\"text\" id=\"value__" + row.propertyId + "__" + row.isRequiredOnRequest + "\" value=\"\"></input>";
                                str += "<div class=\"input-group-append\">";
                                str += "<button  class=\"btn btn btn-secondary btn-sm btn-" + vue.variant + " form-control-sm button-action-symbol\" id=\"symbolId__" + row.propertyId + "__" + row.isRequiredOnRequest + "\" >" + vue.lang.button_Symbol + "</button>";

                                str += "</div></div>";
                                return str;
                            } else if (row.type == LibraryTypes.FOOTPRINT) {
                                let str = "b<div role=\"group\" class=\"input-group\">";
                                str += "<input data-type=\"" + row.type + "\" class=\"form-control form-control-sm new-part\"  type=\"text\" id=\"value__" + row.propertyId + "__" + row.isRequiredOnRequest + "\" value=\"\"></input>";
                                str += "<div class=\"input-group-append\">";
                                str += "<button  class=\"btn btn btn-secondary btn-sm btn-" + vue.variant + " form-control-sm button-action-footprint\" id=\"footprintId__" + row.propertyId + "__" + row.isRequiredOnRequest + "\" >" + vue.lang.button_Footprint + "</button>";

                                str += "</div></div>";
                                return str;
                            

                            } else {
                                let str = "";
                                str += "<div role=\"group\" class=\"input-group input-group-sm\">";
                                str += "<input data-type=\"" + row.type + "\" class=\"form-control new-part\" type=\"text\" id=\"value__" + row.propertyId + "__" + row.isRequiredOnRequest + "\" value=\"\">";
                                str += "</div>";
                                return str;
                            }

                        }

                        return data;
                    }
                }

                columnDefs.push(el);


                var th = document.createElement("th");
                tr.appendChild(th);
                var br = document.createElement("br");
                th.appendChild(br);

                var tx = document.createTextNode(columns[i].name)
                th.appendChild(tx);


            }


            var json = {};
            json.paging = false;
            json.info = false;
            json.dom = 'f<t>';
            json.data = this.properties;
            json.myColumnFormats = columns;
            json.select = false;
            json.columns = cols;
            json.columnDefs = columnDefs;
            json.order = [1, "asc"];


            if ($.fn.dataTable.isDataTable("#t_" + this.id)) {
                this.mainTable.destroy();
                
            }



            this.mainTable = $('#t_' + this.id).DataTable(json);




            //hide first column in table
            this.mainTable.column(0).visible(false);
            this.mainTable.column(1).visible(false);

            //search input change view
            var searchplace = document.getElementById("t_" + this.id + "_filter").firstChild

            while (searchplace.firstChild) {

                if (searchplace.firstChild.textContent == "Search:") {
                    searchplace.removeChild(searchplace.firstChild);
                    break;
                }

            }

            searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
            searchplace.firstChild.setAttribute("class", "form-control form-control-sm")



            let editParts = document.getElementsByClassName('new-part');

            for (var i = 0; i < editParts.length; i++) {
                editParts[i].addEventListener('change', function (e) {

                    let temp = this.id.split("__");

                    let type = $(this).attr("data-type");

                    const obj = {
                        propertyId: temp[1],
                        value: this.value,
                        type: type,
                        isRequiredOnRequest: temp[2]
                    }


                    //vue.$store.dispatch("addPropertyToSavingUL", obj);
                    vue.$store.commit("ADDPROPERTYTOSAVINGUL", obj);
                })
            }

            let symbols_buttons = document.getElementsByClassName('button-action-symbol');

            for (let i = 0, lei = symbols_buttons.length; i < lei; i++) {
                symbols_buttons[i].addEventListener('click', function (e) {

                    let id = this.id;
                    let temp = id.split("__");
                    let f = document.getElementById("value__" + temp[1] + "__" + temp[2])
                    let selectedSymbols = f.value;


                    let funcYes = function (vue) {



                        let str = "";
                        for (let i = 0, lei = vue.$store.getters.selectedSymbols.length; i < lei; i++) {
                            str += vue.$store.getters.selectedSymbols[i];
                            if (i < lei - 1) {
                                str += ", ";
                            }

                        }

                        f.value = str;

                        const obj = {
                            propertyId: temp[1], //todo check type
                            value: str,
                            type: LibraryTypes.PART,
                            isRequiredOnRequest: temp[2]
                        }


                        //vue.$store.dispatch("addPropertyToSavingUL", obj);
                        vue.$store.commit("ADDPROPERTYTOSAVINGUL", obj);

                    }

                    const obj = {
                        title: "Symbols",
                        text: "",
                        type: "symbols",
                        selected: selectedSymbols,
                        buttons: 2,
                        size: "lg",
                        lang: vue.lang.modal_Symbols,
                        funcNo: "",
                        funcYes: funcYes,

                    };
                    vue.$store.dispatch("showModalComponent", obj);
                })
            }

            let footprints_buttons = document.getElementsByClassName('button-action-footprint');

            for (let i = 0, lei = footprints_buttons.length; i < lei; i++) {
                footprints_buttons[i].addEventListener('click', function (e) {


                    let id = this.id;
                    let temp = id.split("__");
                    let f = document.getElementById("value__" + temp[1] + "__" + temp[2])
                    let selectedFootprint = f.value;


                    let funcYes = function (vue) {




                        f.value = vue.$store.getters.selectedFootprints;

                        const obj = {
                            propertyId: temp[1],
                            value: vue.$store.getters.selectedFootprints[0],
                            type: LibraryTypes.FOOTPRINT,
                            isRequiredOnRequest: temp[2]
                        }


                        //vue.$store.dispatch("addPropertyToSavingUL", obj);
                        vue.$store.commit("ADDPROPERTYTOSAVINGUL", obj);

                    }

                    const obj = {
                        title: "Footprints",
                        text: "",
                        type: "footprints",
                        selected: selectedFootprint,
                        buttons: 2,
                        size: "lg",
                        lang: vue.lang.modal_Footprints,
                        funcNo: "",
                        funcYes: funcYes,

                    };
                    vue.$store.dispatch("showModalComponent", obj);
                })
            }


        },*/

    }

}
</script>
<style lang="scss">
@import "./../../scss/_custom.scss";

.NewLibraryFormULComponent {
    table {

        padding: 0px !important;

    }

    table th {
        padding: 0rem !important;

        padding-left: 0.2rem !important;
        padding-right: 0.2rem !important;

    }

    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }

    table td {
        padding: 0.2rem !important;

    }

    .dataTables_filter {
        font-size: 10px;
    }

    .searcher {
        float: left;
    }

    .dataTables_filter .form-control-sm,
    .input-group-sm>.form-control {

        font-size: 0.7rem;
        line-height: 1;
        width: 200px;
    }

    ._dt-body-left {
        text-align: left;
    }

    ._dt-body-right {
        text-align: right;
    }

    ._dt-body-center {
        text-align: center;
    }

    .red {
        color: $redfont;
    }

    .red-img {
        background-color: $red;
        border: 0px;
    }

    .green {
        color: $green;
    }

    .green-img {
        background-color: $green;
        border: 0px;
    }

    .svg-image {
        background-color: white;
        margin: 10px;
        border: 1px solid #cccccc;
    }

    .image-footprint {
        background-color: #ffffff;
        border: 1px solid #dee2e6;
        border-radius: 0.25rem;
        margin-bottom: 3px;
        margin-top: 3px;
        overflow: hidden;
        width: 200px;
        height: 200px;
    }

    .btn {
        height: 26.8px;
    }

    td {
        word-break: break-all;
    }

    input-group {
        min-width: 200px;

    }

    input-group-pn {
        min-width: 150px;

    }

    input-group-prepend {
        height: 26.8px !important;
        widows: 24px;
    }

    .img-thumbnail {
        width: 100px;
    }

    .form-control {
        height: 26.8px;
    }

    .required {
        float: right;
        margin: 2px;
    }

    .type-select {
        padding-top: 5px;
        font-size: 0.7rem;
        padding-left: 5px;
    }

    .library-files {
        width: 60%;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/NewLibraryFormULComponent.vue